import { Component } from '@angular/core';

@Component({
  selector: 'caret',
  template: `<i class="fa fa-caret-down nice-caret"></i>`,
  styleUrls: ['./caret.component.scss'],
})
export class CaretComponent {
  constructor() {}
}
